import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  Form,
  Button,
  Radio,
  Select,
  DatePicker,
  Row,
  Input,
  Col,
  message,
  Upload,
  Space,
  TimePicker,
  Avatar,
  Switch,
} from "antd";
import { Layout } from "antd";
import "antd-country-phone-input/dist/index.css";
import { useDispatch, useSelector } from "react-redux";
import newsFeedAction from "../../../../Redux/NewsFeed/action";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import moment from "moment";
import {
  PlusOutlined,
  DownOutlined,
  AudioOutlined,
  VideoCameraOutlined,
  CameraOutlined,
  EnvironmentOutlined,
  FileOutlined,
  BoldOutlined,
  ItalicOutlined,
  UnderlineOutlined,
  OrderedListOutlined,
  UnorderedListOutlined,
  LinkOutlined,
  CloseOutlined,
  FilterOutlined
} from "@ant-design/icons";
import getBase64 from "../../../../helper/getBase64";
import actions from "../../../../Redux/Organization/action";
import { editNews, getAllspacesByNews } from "../../../../api/News";
import { NewsStatus } from "../../../../types/News";
import "./PostAdd.css"
import PostPreview from "./PostPreview";
import FileUploader from "../../../../helper/FileUploader";
import VideoUpload from "../../../../components/global/VideoUpload";
import DocUpload from "../../../../components/global/UploadDocument";
import AudioUpload from "../../../../components/global/AudioUpload";
import dummy from '../../../../assets/Images/No-image-found.jpeg'
import Loader from "helper/Loader";
import FiltersModal from "./FiltersModal";
import { debounce } from "lodash";
import MapModal from "helper/Map/MapModal";
import ViewAddress from "helper/Map/ViewAddress";
import fileUploadActions from "../../../../Redux/FileUpload/action";

const { Option } = Select;

const PostAdd = ({ organizationData, editData, handleCancel, onNewsPosted, isEditMode = false }: any) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [quillReady, setQuillReady] = useState(false);
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState(editData?.photo || "");
  const [showMoreOptions, setShowMoreOptions] = useState(false);
  const [schedulePublication, setSchedulePublication] = useState(false);
  const [linkToEvent, setLinkToEvent] = useState(false);
  const [scheduledDate, setScheduledDate] = useState<any>(null);
  const [scheduledTime, setScheduledTime] = useState<any>(null);
  const [describe, setDescribe] = useState(editData?.text || "");
  const [showPreview, setShowPreview] = useState(false);
  const [latestSearchQuery, setLatestSearchQuery] = useState('');
  const fileData = useSelector((state: any) => state.fileUpload.fileData);
  const [mapModalVisible, setMapModalVisible] = useState(false);
  const [locationData, setLocationData] = useState<any>(editData?.address || null);

  // Media avatar states like FeaturedImageCard
  const [audioAvatar, setAudioAvatar] = useState<string>("");
  const [videoAvatar, setVideoAvatar] = useState<string>("");
  const [imageAvatar, setImageAvatar] = useState<string>("");
  const [documentAvatar, setDocumentAvatar] = useState<string>("");

  const [imageIds, setImageIds] = useState<string[]>(editData?.imageIds || []);
  const [imagesData, setImagesData] = useState<any[]>([]);
  const [videoIds, setVideoIds] = useState<string[]>(editData?.videoIds || []);
  const [videosData, setVideosData] = useState<any[]>([]);
  const [documentIds, setDocumentIds] = useState<string[]>(editData?.documentIds || []);
  const [documentsData, setDocumentsData] = useState<any[]>([]);
  const [audioIds, setAudioIds] = useState<string[]>(editData?.audioIds || []);
  const [audiosData, setAudiosData] = useState<any[]>([]);
  const [eventsData, setEventsData] = useState<any[]>([]);
  const [eventsLoading, setEventsLoading] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState<any>(null);
  const [filtersModalVisible, setFiltersModalVisible] = useState(false);
  const [eventFilters, setEventFilters] = useState<any>({});
  const isEditingPost = isEditMode && editData?._id

  interface EventFilters {
    spaceType?: string
    dates?: string
    organizationIds?: string[]
  }

  useEffect(() => {
    dispatch({
      type: actions.GET_ORGANIZATIONS,
    });
  }, [dispatch]);

  useEffect(() => {
    setQuillReady(true);
  }, []);

  // Update form values when editData changes
  useEffect(() => {
    if (isEditMode && editData?._id) {
      const newFormSchema = {
        organization: editData?.organization
          ? JSON.stringify({
            orgId: editData.organization.id,
            name: editData.organization.name,
            avatar: editData.organization.photo?.post,
            ownerId: editData.organizerId,
          })
          : undefined,
        title: editData?.title || "",
        describe: editData?.text || "",
        photo: editData?.photo || "",
        schedule: false,
        schedule_date: editData?.scheduledAt ? moment(editData.scheduledAt) : null,
        schedule_time: editData?.scheduledAt ? moment(editData.scheduledAt) : null,
        linkedEvent: editData?.linkedEvent?._id || editData?.linkedEvent || null,
      };

      form.setFieldsValue(newFormSchema);
      setDescribe(editData?.text || "");
      setImageUrl(editData?.photo || "");

      // Set selected event if exists
      if (editData?.linkedEvent) {
        setSelectedEvent(editData.linkedEvent._id || editData.linkedEvent);
        setLinkToEvent(true);
      }

      // Set schedule state if editing a scheduled post
      if (editData?.scheduledAt) {
        const scheduledDateTime = moment(editData.scheduledAt);
        setSchedulePublication(true);
        setScheduledDate(scheduledDateTime);
        setScheduledTime(scheduledDateTime);
      }
    }

  }, [editData, isEditMode, form]);

  useEffect(() => {
    if (!fileData?._id) return;

    if (
      fileData.altText === 'audio' ||
      fileData.description === 'audio_file' ||
      fileData.description === 'audio_recording'
    ) {
      setAudioIds(prev =>
        prev.includes(fileData._id) ? prev : [...prev, fileData._id]
      );

      setAudiosData(prev =>
        prev.some(a => a.id === fileData._id)
          ? prev
          : [...prev, { id: fileData._id, url: fileData.link, name: fileData.title }]
      );
    } else {
      setImageIds(prev =>
        prev.includes(fileData._id) ? prev : [...prev, fileData._id]
      );

      setImagesData(prev =>
        prev.some(i => i.id === fileData._id)
          ? prev
          : [...prev, { id: fileData._id, url: fileData.link }]
      );
    }

    dispatch({ type: fileUploadActions.CLEAR_FILE_DATA });
  }, [fileData]);

  const handleImageUpload = () => { };

  const uploadButton = (
    <div>
      {loading ? (
        <></>
      ) : (
        <>
          <PlusOutlined />
          <div style={{ marginTop: 8 }}>Upload</div>
        </>
      )}
    </div>
  );

  const formSchema = {
    organization: editData?.organization
      ? JSON.stringify({
        orgId: editData.organization.id,
        name: editData.organization.name,
        avatar: editData.organization.photo?.post,
        ownerId: editData.organizerId,
      })
      : undefined,
    title: editData?.title || "",
    describe: editData?.text || "",
    photo: editData?.photo || "",
    schedule: false,
    schedule_date: null,
    schedule_time: null,
  };
  const fetchEventsWithSearch = useCallback(
    async (searchQuery: string) => {
      setEventsLoading(true);
      try {
        const params: any = { page: 1, limit: 10, ...eventFilters };
        if (searchQuery) params.searchString = searchQuery;

        const response = await getAllspacesByNews(params);

        if (response) {
          setEventsData(response);
        }
      } finally {
        setEventsLoading(false);
      }
    },
    [eventFilters]
  );

  const debouncedFetchEvents = useMemo(
    () => debounce((query: string) => fetchEventsWithSearch(query), 500),
    [fetchEventsWithSearch]
  );


  const fetchEvents = async (page = 1, limit = 10, filters: EventFilters = {}) => {
    try {
      setEventsLoading(true);

      const params = {
        page,
        limit,
        ...(filters.spaceType && { spaceType: filters.spaceType }),
        ...(filters.dates && { date: filters.dates }),
        ...(filters.organizationIds && {
          organizationId: filters.organizationIds,
        }),
      };

      const response = await getAllspacesByNews(params);

      if (response) {
        setEventsData(response);
      }
    } finally {
      setEventsLoading(false);
    }
  };

  const handleFiltersApply = (filters: any) => {
    setEventFilters(filters);
    setFiltersModalVisible(false);
    fetchEvents(1, 10, filters);
  };

  const handleFiltersClear = () => {
    setEventFilters({});
    setFiltersModalVisible(false);
    fetchEvents(1, 10, {});
  };

  useEffect(() => {
    if (linkToEvent) {
      fetchEvents();
    }
  }, [linkToEvent]);

  const handlePreview = () => {
    const formValues = form.getFieldsValue();
    const organization = JSON.parse(formValues.organization || '{}');
    setShowPreview(true);
  };

  const handlePreviewCancel = () => {
    setShowPreview(false);
  };

  const handlePreviewBack = () => {
    setShowPreview(false);
  };

  const handlePreviewEdit = () => {
    setShowPreview(false);
  };

  const handlePreviewPost = () => {
    setShowPreview(false);
    form.submit();
  };

  const handleShare = () => {
    // Implement share functionality
    console.log('Share post');
  };

  const handleUnpublish = () => {
    // Implement unpublish functionality
    console.log('Unpublish post');
  };

  const getPreviewData = () => {
    const formValues = form.getFieldsValue();
    const organization = JSON.parse(formValues.organization || '{}');

    // Find the selected event from eventsData
    const linkedEvent = selectedEvent ? eventsData.find((event: any) => event._id === selectedEvent) : null;

    return {
      title: formValues.title || 'Bamrec News',
      description: formValues.describe || '',
      authorAvatar: organization.avatar || undefined,
      authorName: organization.name || undefined,
      status: editData?.status || NewsStatus.Published,
      // Include media data for preview
      imageIds,
      videoIds,
      documentIds,
      audioIds,
      imagesData,
      videosData,
      documentsData,
      audiosData,
      imageUrl, // For backward compatibility
      linkedEvent, // Add linked event data
    };
  };

  const onFinish = (values: any) => {
    const organization = JSON.parse(values.organization);

    // Determine status and scheduledAt
    let status = NewsStatus.Published;
    let scheduledAt = null;

    if (schedulePublication && scheduledDate && scheduledTime) {
      // Combine date and time using moment
      const scheduledDateTime = scheduledDate.clone();
      const timeParts = scheduledTime.format('HH:mm');
      const [hours, minutes] = timeParts.split(':');
      scheduledDateTime.hour(parseInt(hours));
      scheduledDateTime.minute(parseInt(minutes));
      scheduledDateTime.second(0);

      // Check if the scheduled time is in the future
      const now = moment();
      if (scheduledDateTime.isAfter(now)) {
        status = NewsStatus.Scheduled;
        scheduledAt = scheduledDateTime.toISOString();
      }
    }

    const payload = {
      organizationId: organization?.orgId,
      title: values.title,
      text: values.describe,
      organizerId: organization?.ownerId,
      status,
      ...(scheduledAt && { scheduledAt }),
      // Include linked event if selected
      ...(selectedEvent && { linkedEvent: selectedEvent }),
      // Include image IDs for backend
      ...(imageIds.length > 0 && { imageIds }),
      ...(selectedEvent && { spaceId: selectedEvent }),
      // Include video IDs for backend
      ...(videoIds.length > 0 && { videoIds }),
      ...(values.address && { address: values.address }),
      // Include document IDs for backend
      ...(documentIds.length > 0 && { documentIds }),
      // Include audio IDs for backend
      ...(audioIds.length > 0 && { audioIds })
    }

    if (isEditMode && editData?._id) {
      // Edit existing news
      editNews(editData._id, payload)
        .then(() => {
          form.resetFields();
          setDescribe("");
          setImageUrl("");
          setSchedulePublication(false);
          setScheduledDate(null);
          setScheduledTime(null);
          setAudioIds([]);
          setAudiosData([]);
          handleCancel();
          if (onNewsPosted) {
            onNewsPosted();
          }
        })
        .catch((error) => {
          console.error('Error updating news:', error);
        });
    } else {
      // Create new news
      dispatch({
        type: newsFeedAction.ADD_NEWSFEED_DATA,
        payload: payload,
      });
      form.resetFields();
      setDescribe("");
      setImageUrl("");
      setSchedulePublication(false);
      setScheduledDate(null);
      setScheduledTime(null);
      setAudioIds([]);
      setAudiosData([]);
      handleCancel();

      // Call the callback to refresh news data
      if (onNewsPosted) {
        onNewsPosted();
      }
    }

    // if (isEditingPost){
    //   data.id = editData?.id
    // }

    // let newsFeedData = [];
    // newsFeedData =
    //   JSON.parse(localStorage.getItem("newsFeedData") || "[]") || [];
    // if (editData?.id) {
    //   newsFeedData.forEach((item: any, index: any) => {
    //     if (item.id === data.id) {
    //       newsFeedData[index] = data;
    //     }
    //   });
    // } else {
    //   newsFeedData.push(data);
    // }
    // message.success("completed");

    // handleCancel();
  };

  return (
    <Layout className="news-modal-layout">
      <Form
        form={form}
        name="nest-messages"
        onFinish={onFinish}
        initialValues={formSchema}
        layout={"vertical"}
        autoComplete="off"
        className="news-form"
      >
        <Form.Item
          name="organization"
          rules={[{ required: true, message: "Please select organization" }]}
          label="Organization"
        >
          <Select
            placeholder="Select organization"
            className="organization-dropdown"
            style={{ marginBottom: "5px" }}
            suffixIcon={<DownOutlined />}
            allowClear
          >
            {organizationData.map((item: any) => (
              <Option
                key={item.id}
                value={JSON.stringify({
                  orgId: item.id,
                  name: item.name,
                  avatar: item.photo?.post,
                  ownerId: item.ownerId,
                })}
              >
                <Space>
                  <Avatar src={item.photo?.post} size="small" />
                  {item.name}
                </Space>
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="title"
          rules={[{ required: true, message: 'Please enter news title' }]}
          className="title-input-item"
          label="News Title"
        >
          <Input placeholder="News Title" style={{ width: '100%', marginBottom: '17px' }} />

        </Form.Item>

        <Form.Item
          name="describe"
          className="content-input-item"
        >
          <div className="editor-container">
            <div id="quill-toolbar" className="editor-toolbar">
              <button className="ql-ai ai-btn">AI</button>
              <button className="ql-bold"><BoldOutlined /></button>
              <button className="ql-italic"><ItalicOutlined /></button>
              <button className="ql-underline"><UnderlineOutlined /></button>
              <button className="ql-list" value="ordered"><OrderedListOutlined /></button>
              <button className="ql-list" value="bullet"><UnorderedListOutlined /></button>
              <button className="ql-link"><LinkOutlined /></button>
            </div>
            {quillReady && (
              <ReactQuill
                placeholder="Write a News..."
                theme="snow"
                value={describe}
                onChange={(value) => {
                  setDescribe(value);
                  form.setFieldsValue({ describe: value });
                }}
                modules={{
                  toolbar: {
                    container: '#quill-toolbar',
                  },
                }}
                formats={[
                  'header',
                  'size',
                  'bold',
                  'italic',
                  'underline',
                  'list',
                  'bullet',
                  'link',
                  'image',
                ]}
              />
            )}

          </div>
        </Form.Item>
        <Form.Item name="address" hidden>
          <Input />
        </Form.Item>

        <div className="more-options-section">
          <Button
            type="link"
            className="more-options-button"
            onClick={() => setShowMoreOptions(!showMoreOptions)}
          >
            More options
            <DownOutlined rotate={showMoreOptions ? 180 : 0} />
          </Button>

          {showMoreOptions && (
            <>
              <div className="more-options-content" style={{ marginBottom: '5px' }}>
                <div className="option-container">
                  <div className="option-item">
                    <div className="option-label">Schedule publication</div>
                    <Switch
                      checked={schedulePublication}
                      onChange={(checked) => {
                        setSchedulePublication(checked);
                        if (!checked) {
                          setScheduledDate(null);
                          setScheduledTime(null);
                          form.setFieldsValue({
                            schedule_date: null,
                            schedule_time: null
                          });
                        }
                      }}
                    />
                  </div>
                  {schedulePublication && (
                    <div className="schedule-row">
                      <div className="schedule-date">
                        <label className="input-label">Date</label>
                        <DatePicker
                          placeholder="Select date"
                          className="schedule-date"
                          format="MM/DD/YYYY"
                          value={scheduledDate}
                          onChange={(date) => {
                            setScheduledDate(date);
                            form.setFieldsValue({ schedule_date: date });
                          }}
                          disabledDate={(current) =>
                            current && current < moment().startOf('day')
                          }
                        />
                      </div>
                      <div className="schedule-time">
                        <label className="input-label">Time</label>
                        <TimePicker
                          placeholder="Select time"
                          className="schedule-time"
                          format="h:mm A"
                          use12Hours
                          value={scheduledTime}
                          onChange={(time) => {
                            setScheduledTime(time);
                            form.setFieldsValue({ schedule_time: time });
                          }}
                          disabledTime={() => {
                            if (!scheduledDate || !scheduledDate.isSame(moment(), 'day')) {
                              return {};
                            }

                            const now = moment();

                            return {
                              disabledHours: () =>
                                Array.from({ length: now.hour() }, (_, i) => i),

                              disabledMinutes: (hour) =>
                                hour === now.hour()
                                  ? Array.from({ length: now.minute() }, (_, i) => i)
                                  : [],
                            };
                          }}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="option-container">
                <div className="option-item">
                  <div className="option-label" style={{ marginBottom: '20px' }}>Link to Event</div>
                  <Switch
                    checked={linkToEvent}
                    onChange={setLinkToEvent}
                  />
                </div>
                {linkToEvent &&
                  <>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}
                    >
                      <label className="input-label" style={{ marginTop: '5px' }}>Select event</label>
                      <Button
                        icon={<FilterOutlined />}
                        onClick={() => setFiltersModalVisible(true)}
                        style={{
                          width: '109px',
                          height: '37px',
                          fontSize: '14px',
                          fontWeight: '600',
                          borderRadius: '8px',
                          border: "1px solid #2BA7CA",
                          color: "#2BA7CA",
                          marginBottom: '5px'
                        }}
                      >
                        Filters {Object.keys(eventFilters).length > 0 && `(${Object.keys(eventFilters).length})`}
                      </Button>
                    </div>
                    <Select
                      placeholder="Select"
                      className="link-event-field"
                      loading={eventsLoading}
                      showSearch
                      filterOption={false}
                      onSearch={(value) => {
                        setLatestSearchQuery(value);
                        debouncedFetchEvents(value);
                      }}
                      allowClear
                      value={selectedEvent}
                      onChange={(value) => {
                        setSelectedEvent(value);
                        form.setFieldsValue({ linkedEvent: value });
                      }}
                      optionFilterProp="label"
                      notFoundContent={eventsLoading ? <div style={{ textAlign: 'center', padding: '10px' }}>
                        <Loader />
                      </div> : 'No events found'}
                    >
                      {eventsData.map((event: any) => (
                        <Option
                          key={event._id}
                          value={event._id}
                          label={event.name}
                        >
                          <Space>
                            <Avatar
                              src={event.coverPhotos?.[0]?.post || dummy}
                              size="small"
                            />
                            {event.name}
                          </Space>
                        </Option>
                      ))}
                    </Select>
                  </>

                }

              </div>
            </>
          )}
        </div>
        {imageIds.length > 0 && (
          <div className="uploaded-images-section">
            <div className="images-grid">
              {imagesData.map((image, index) => (
                <div
                  key={image.id}
                  className={
                    index === 0 && imagesData.length > 1
                      ? "image-item full-width-image"
                      : "image-item three-col-image"
                  }
                >
                  <img
                    src={image.url ? image.url : dummy}
                    alt={`Uploaded ${index + 1}`}
                    className="uploaded-image"
                  />
                  <Button
                    type="text"
                    icon={<CloseOutlined />}
                    className="remove-image-btn"
                    onClick={() => {
                      setImageIds(prev => prev.filter((_, i) => i !== index));
                      setImagesData(prev => prev.filter((_, i) => i !== index));
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        )}

        {audioIds.length > 0 && (
          <div className="uploaded-audio-section" style={{ marginTop: '20px' }}>
            <div className="audio-list">
              {audiosData.map((audio, index) => (
                <div
                  key={audio.id}
                  className="audio-item"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '10px',
                    border: '1px solid #d9d9d9',
                    borderRadius: '6px',
                    marginBottom: '8px',
                    backgroundColor: '#fafafa'
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                    <AudioOutlined style={{ marginRight: '10px', color: '#1890ff' }} />
                    <audio
                      controls
                      preload="metadata"
                      style={{ flex: 1, marginRight: '10px', minHeight: '32px' }}
                      key={audio.id}
                    >
                      <source src={audio.url} type="audio/mpeg" />
                      <source src={audio.url} type="audio/wav" />
                      <source src={audio.url} type="audio/mp3" />
                      <source src={audio.url} type="audio/ogg" />
                      Your browser does not support the audio element.
                    </audio>
                    {/* <span style={{ fontSize: '14px', color: '#666' }}>
                      {audio.name || `Audio ${index + 1}`}
                    </span> */}
                  </div>
                  <Button
                    type="text"
                    icon={<CloseOutlined />}
                    className="remove-audio-btn"
                    onClick={() => {
                      setAudioIds(prev => prev.filter((_, i) => i !== index));
                      setAudiosData(prev => prev.filter((_, i) => i !== index));
                    }}
                  />
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="media-section">
          <div className="option-label">Add:</div>
          <div className="media-buttons">
            <AudioUpload
              audioIds={audioIds}
              setAudioIds={setAudioIds}
              soruceType="other"
              multiple={false}
            />
            <VideoUpload
              component='News'
              videoIds={videoIds}
              setVideoIds={setVideoIds}
              sourceType="other"
              multiple={false}

            />
            <Button
              icon={<EnvironmentOutlined />}
              className="media-button"
              onClick={() => setMapModalVisible(true)}
            >
              Location
            </Button>
            <Form.Item name="imageFile" style={{ margin: 0 }}>
              <FileUploader
                component='News'
                setAvatar={handleImageUpload}
                name="imageFile"
                form={form}
                icon={<CameraOutlined />}
                className="media-button"
              />
            </Form.Item>
            {/* <Button icon={<EnvironmentOutlined />} className="media-button" >
              Location
            </Button> */}
            <DocUpload
              component='News'
              documentIds={documentIds}
              setDocumentIds={setDocumentIds}
              soruceType="other"
              multiple={false}
              docType=".pdf,.doc,.docx,.txt"
            />
          </div>
        </div>
        {locationData && (
          <div className="location-preview">
            <div className="location-preview-header">
              <EnvironmentOutlined />
              <span>
                {`${locationData.street || ""}, ${locationData.city || ""}, ${locationData.country || ""}`}
              </span>
            </div>

            <div className="location-map-wrapper">
              <ViewAddress onlyView mapData={locationData} />
            </div>
          </div>
        )}
        {/* Show uploaded images */}

        <div className="form-actions">
          <Button
            size="large"
            style={{
              color: '#2BA7CA',
              fontWeight: '500',
              border: 'none'
            }}
            onClick={handleCancel}
          >
            Cancel
          </Button>
          <Button
            size="large"
            style={{
              width: '109px',
              height: '37px',
              fontSize: '14px',
              fontWeight: '600',
              borderRadius: '8px',
              border: "1px solid #2BA7CA",
              color: "#2BA7CA"
            }}
            onClick={handlePreview}
          >
            Preview
          </Button>
          <Button
            type="primary"
            size="large"
            style={{
              width: '84px',
              height: '37px',
              fontSize: '14px',
              fontWeight: '600',
              borderRadius: '8px',
              backgroundColor: '#2BA7CA'
            }}
            htmlType="submit"
            loading={loading}
          >
            {isEditingPost ? "Update" : "Post"}
          </Button>
        </div>
      </Form>

      {mapModalVisible && (
        <MapModal
          setMapModalVisible={setMapModalVisible}
          setMapModalData={(data: any) => {
            setLocationData(data);

            // update antd form
            form.setFieldsValue({
              address: data,
            });
          }}
          mapData={locationData}
          setFieldsValue={(data: any) =>
            form.setFieldsValue({ address: data })
          }
        />
      )}

      <PostPreview
        visible={showPreview}
        onCancel={handlePreviewCancel}
        onBack={handlePreviewBack}
        onEdit={handlePreviewEdit}
        onPost={handlePreviewPost}
        onShare={handleShare}
        onUnpublish={handleUnpublish}
        postData={getPreviewData()}
        imagesData={imagesData}
        videosData={videosData}
        documentsData={documentsData}
        audiosData={audiosData}
      />

      <FiltersModal
        visible={filtersModalVisible}
        onCancel={() => setFiltersModalVisible(false)}
        onApply={handleFiltersApply}
        onClear={handleFiltersClear}
        initialFilters={eventFilters}
      />
    </Layout>
  );
};
export default PostAdd;
